<template>
  <div class="min-h-screen bg-background p-6 pb-24 pt-safe">
    <!-- Header -->
    <div class="flex items-center gap-4 mb-6 mt-12">
      <button
        @click="router.back()"
        class="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center active:scale-95"
      >
        <span class="text-xl">←</span>
      </button>
      <h1 class="text-xl font-bold text-textMain">隱私政策</h1>
    </div>

    <div class="bg-white rounded-2xl shadow-sm p-6 space-y-6">
      <p class="text-xs text-textMuted">最後更新日期：2024 年 12 月 18 日</p>

      <p class="text-sm text-textMain leading-relaxed">
        歡迎使用「寶寶接種小幫手」（以下簡稱「本應用程式」）。我們非常重視您的隱私，本政策說明我們如何收集、使用及保護您的個人資料。
      </p>

      <section>
        <h2 class="font-bold text-textMain mb-2">1. 我們收集的資料</h2>
        <p class="text-sm text-textMuted leading-relaxed">為了提供疫苗接種追蹤及提醒服務，本應用程式可能收集以下資料：</p>
        <ul class="text-sm text-textMuted list-disc pl-5 mt-2 space-y-1">
          <li><strong>寶寶資料</strong>：暱稱、性別、出生日期</li>
          <li><strong>疫苗接種記錄</strong>：疫苗種類、預計日期、實際接種日期</li>
          <li><strong>帳號資料</strong>：電子郵件地址（僅在您選擇建立帳號時）</li>
          <li><strong>裝置識別碼</strong>：用於推播通知的 FCM Token</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">2. 資料使用目的</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>計算並顯示疫苗接種時程</li>
          <li>發送疫苗接種提醒通知</li>
          <li>在您的多個裝置間同步資料</li>
          <li>改善應用程式功能與使用體驗</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">3. 資料儲存與安全</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>您的資料儲存於 Google Firebase 雲端服務</li>
          <li>資料傳輸過程使用 HTTPS 加密</li>
          <li>僅有您本人可存取您的資料（透過 Firebase 身份驗證）</li>
          <li>我們不會將您的資料出售或分享給第三方</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">4. 資料保留期限</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          您的資料將保留至您主動刪除帳號為止。您可以隨時在應用程式的「設定」頁面中刪除帳號，所有相關資料將永久刪除。
        </p>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">5. 第三方服務</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          本應用程式使用 Google Firebase 用於身份驗證、資料儲存及推播通知。
        </p>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">6. 兒童隱私</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          本應用程式設計供家長使用，用於記錄其子女的疫苗接種資訊。我們不會直接向 13 歲以下兒童收集資料。
        </p>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">7. 您的權利</h2>
        <ul class="text-sm text-textMuted list-disc pl-5 space-y-1">
          <li>存取您的個人資料</li>
          <li>更正不正確的資料</li>
          <li>刪除您的帳號及所有相關資料</li>
          <li>拒絕接收推播通知</li>
        </ul>
      </section>

      <section>
        <h2 class="font-bold text-textMain mb-2">8. 政策變更</h2>
        <p class="text-sm text-textMuted leading-relaxed">
          我們可能會不定期更新本隱私政策。重大變更時，我們將透過應用程式通知您。
        </p>
      </section>

      <section class="bg-gray-50 rounded-xl p-4">
        <h2 class="font-bold text-textMain mb-2">9. 聯絡我們</h2>
        <p class="text-sm text-textMuted">如有任何隱私相關問題，請透過以下方式聯絡我們：</p>
        <p class="text-sm text-primary mt-1">📧 igoouttw@gmail.com</p>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
</script>
